import React, {FunctionComponent, useContext, useEffect, useRef} from 'react';
import './ScrollAnchor.less';

interface ScrollAnchorProps {
	id: string;
	selectedItemId: string;
	onVisible?: (isVisible: boolean) => void,
	hasClick?: boolean;
}

export const ScrollAnchor: FunctionComponent<ScrollAnchorProps> = ({id, selectedItemId, onVisible, hasClick, children}) => {
	const container = useRef(null);

	//check if element is on screen
	useEffect(() => {
		if (!onVisible) {
			return;
		}

		const intersectOptions = {
			threshold: 1.0,
			rootMargin: '0px 0px -80% 0px'
		};

		const observer = new IntersectionObserver(([e]) => {
			return onVisible(e.isIntersecting);

		}, intersectOptions);

		observer.observe(container.current);
	}, []);

	//click to scroll
	useEffect(() => {
		if (hasClick && id === selectedItemId) {
			container?.current?.scrollIntoView();
		}
	}, [selectedItemId]);

	return (
		<div className="scroll-anchor" key={id} id={id} ref={container}>{children}</div>
	);
};
